var __jsx = React.createElement;
import React from 'react';
import SAR from "@componentsShared/SAR/SAR";
import { useTranslation } from "@i18n";

// TypeScript Interfaces

// Reusable Components

var InfoCard = function InfoCard(_ref) {
  var label = _ref.label,
    subtitle = _ref.subtitle,
    value = _ref.value,
    unit = _ref.unit,
    _ref$showPriceIcon = _ref.showPriceIcon,
    showPriceIcon = _ref$showPriceIcon === void 0 ? false : _ref$showPriceIcon;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start items-start gap-1.5 min-w-32 en:w-[140px] "
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-[3px] h-full min-h-16 bg-blue-800 rounded-3xl"
  }), /*#__PURE__*/React.createElement("div", {
    className: "inline-flex flex-col justify-center items-start gap-[3px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-start justify-start text-black text-sm font-bold leading-5"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "text-start justify-start text-gray-text text-xs font-medium leading-4"
  }, subtitle), /*#__PURE__*/React.createElement("div", {
    className: "inline-flex justify-start items-center gap-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-start justify-start"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-primary-old text-sm font-bold leading-5"
  }, value), unit && /*#__PURE__*/React.createElement("span", {
    className: "text-primary-old text-sm font-medium leading-5 md:text-base"
  }, ' ', unit)), showPriceIcon && /*#__PURE__*/React.createElement(SAR, {
    className: "text-primary-old"
  }))));
};
var FinancingDetailsCard = function FinancingDetailsCard(_ref2) {
  var financing = _ref2.financing;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full relative bg-white rounded-lg shadow-[0px_0px_5px_0px_rgba(60,86,212,0.40)] overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full p-3 inline-flex flex-col justify-start items-start gap-4 md:p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-start items-start gap-4 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inline-flex justify-between items-center gap-[52px] w-full md:max-w-[460px]"
  }, /*#__PURE__*/React.createElement(InfoCard, {
    label: financing.duration.label,
    subtitle: financing.duration.subtitle,
    value: financing.duration.value,
    unit: financing.duration.unit
  }), /*#__PURE__*/React.createElement(InfoCard, {
    label: financing.monthlyPayment.label,
    subtitle: financing.monthlyPayment.subtitle,
    value: financing.monthlyPayment.value,
    showPriceIcon: financing.monthlyPayment.showPriceIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: "inline-flex justify-between items-center gap-12 w-full md:max-w-[460px]"
  }, /*#__PURE__*/React.createElement(InfoCard, {
    label: financing.finalPayment.label,
    subtitle: financing.finalPayment.subtitle,
    value: financing.finalPayment.value,
    showPriceIcon: financing.finalPayment.showPriceIcon
  }), /*#__PURE__*/React.createElement(InfoCard, {
    label: financing.firstPayment.label,
    subtitle: financing.firstPayment.subtitle,
    value: financing.firstPayment.value,
    showPriceIcon: financing.firstPayment.showPriceIcon
  }))), /*#__PURE__*/React.createElement("div", {
    className: "text-start justify-start text-gray-700 text-xs font-medium leading-6 md:text-sm"
  }, financing.description)));
};
var CashPriceCard = function CashPriceCard(_ref3) {
  var cashPrice = _ref3.cashPrice;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement("div", {
    className: "self-stretch relative bg-white rounded-lg shadow-[0px_0px_5px_0px_rgba(60,86,212,0.40)] overflow-hidden p-4 md:flex-[30%]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full inline-flex justify-start items-start gap-1.5 h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-[3px] min-h-20 h-full bg-blue-800 rounded-3xl md:max-h-20"
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-full inline-flex flex-col justify-start items-start gap-4"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-start justify-start text-black text-sm font-bold leading-5 md:text-base"
  }, tShort("pricing/cash_start_from", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("div", {
    className: "inline-flex justify-start items-center gap-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-start justify-start text-primary-old text-sm font-bold leading-5"
  }, cashPrice.value), /*#__PURE__*/React.createElement(SAR, {
    className: "text-primary-old"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "inline-flex justify-start items-center gap-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-start justify-start text-slate-500 text-xs font-medium leading-4"
  }, cashPrice.disclaimer), /*#__PURE__*/React.createElement("div", {
    className: "w-3 h-3 relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-2.5 h-2.5 outline outline-1 outline-offset-[-0.50px] outline-slate-500"
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-0 h-[0.81px] outline outline-1 outline-offset-[-0.50px] outline-slate-500"
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-0 h-1.5 outline outline-1 outline-offset-[-0.50px] outline-slate-500"
  }))))));
};

// Main Component
var FinancingPrices = function FinancingPrices(_ref4) {
  var title = _ref4.title,
    financing = _ref4.financing,
    cashPrice = _ref4.cashPrice;
  // Component should not render if no data is provided
  if (!financing || !cashPrice || !title) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full inline-flex flex-col justify-start items-start gap-4 md:gap-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "self-stretch text-start justify-start text-primary-old text-base font-bold leading-8"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "self-stretch flex flex-col justify-start items-start gap-2 md:flex-row md:gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full inline-flex justify-start items-center gap-4 md:flex-[70%]"
  }, /*#__PURE__*/React.createElement(FinancingDetailsCard, {
    financing: financing
  })), /*#__PURE__*/React.createElement(CashPriceCard, {
    cashPrice: cashPrice
  })));
};
export default FinancingPrices;